import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { ReportService } from '../report.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';

@Component({
  selector: 'app-exams-eval-marks-report',
  templateUrl: './exams-eval-marks-report.component.html',
  styleUrls: ['./exams-eval-marks-report.component.scss']
})
export class ExamsEvalMarksReportComponent implements OnInit {

  reportForm: FormGroup;
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  CourseList: any[] = [];
  filteredListCourse: any[] = [];
  examList: any[] = [];
  filteredListExam: any[] = [];
  dialogRef: MatDialogRef<any>;

  isDownloadingEvaluation = false;
  isDownloadingZero       = false;
  isDownloadingChecklist  = false;

  private readonly CHECKLIST_RPT_CODE  = 183;

  private readonly EVALUATION_RPT_CODE = 303;

  private readonly ZERO_MARKS_RPT_CODE = 304;

  constructor(
    private spinner: NgxSpinnerService,
    public  umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    private router: Router,
    private reportService: ReportService
  ) { }

  ngOnInit(): void {
    this.reportForm = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      course:    new FormControl('', Validators.required),
      EmId:      new FormControl('', Validators.required)
    });

    this.fetchSession();
  }



  fetchSession(): void {
    this.spinner.show();
    this.umsService.getSession({ SnDefault: '', SnNo: '' }).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.sessionList = [];
        if (res.status) {
          res.data.forEach((el: any) => {
            if (el.SnStatus === 'O') this.sessionList.push(el);
          });
          this.SessionFilterList = this.sessionList.slice();
        }
      },
      () => {
        this.spinner.hide();
        this.sessionList = [];
        this.SessionFilterList = [];
      }
    );
  }

  getCourse(item: any): void {
    this.spinner.show();
    this.reportForm.get('course').setValue('');
    this.reportForm.get('EmId').setValue('');
    this.CourseList = [];
    this.filteredListCourse = [];
    this.examList = [];
    this.filteredListExam = [];

    this.umsService.getCourse({ SessionId: item.SnNo }).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.CourseList = res.data || [];
          this.filteredListCourse = this.CourseList.slice();
        }
      },
      () => {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    );
  }

  getExamList(item: any): void {
    this.spinner.show();
    this.reportForm.get('EmId').setValue('');
    this.examList = [];
    this.filteredListExam = [];

    this.umsService.getExam({ EmCoCode: item.CoCode }).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.examList = res.data || [];
          this.filteredListExam = this.examList.slice();
        } else {
          this.showError(res.message || 'Failed to fetch exams.');
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.showError(ERROR.error?.message || 'Failed to fetch exams.');
      }
    );
  }



  isReportReady(): boolean {
    const v = this.reportForm.value;
    return !!(v.SessionId && v.course && v.EmId);
  }

  private buildFilter(rptCode: number, extraPayload: any): any {
    const v = this.reportForm.value;
    const userId = parseInt(sessionStorage.getItem('userId'), 10) || 0;
    return {
      LoginId:  userId,
      RptCode:  183,
      InstName: '',
      InstNo:   this.umsService.secretdata?.['ClubPartTrans'] || 0,
      ShId:     '',
      CgCode:   '',
      RollNo:   '',
      Cent:     '',
      TnCode:   '',
      EsId:     0,
      CsNo:     '',
      PgBreak:  '',
      StrId:    0,
      StrCode:  '',
      RgNo:     '',
      UC:       '',
      Ledger:   '',
      RegnRoll: '',
      DsCode:   '',
      CoCode:   v.course,
      SnNo:     v.SessionId,
      Extra1:   JSON.stringify(extraPayload),
      Mode:     true
    };
  }


  downloadEvaluationReport(): void {
    this.downloadHbsReport(0, 'Evaluation');
  }

  downloadZeroMarksReport(): void {
    this.downloadHbsReport(1, 'Zero');
  }


  downloadChecklistReport(): void {
    if (!this.isReportReady()) {
      this.showError('Please select Session, Course and Exam first.');
      return;
    }

    this.isDownloadingChecklist = true;
    this.spinner.show();

    const v = this.reportForm.value;
    const spParams: any = {
      CoCode: v.course,
      SnNo:   v.SessionId,
      EmId:   v.EmId,
      IsZero: 0
    };

    const filter = this.buildFilter(this.CHECKLIST_RPT_CODE, spParams);
    this.umsService.setData(JSON.stringify(filter));
    this.router.navigate(['hbsreports']);

    setTimeout(() => {
      this.spinner.hide();
      this.isDownloadingChecklist = false;
    }, 1500);
  }

  private downloadHbsReport(isZero: 0 | 1, label: 'Evaluation' | 'Zero'): void {
    if (!this.isReportReady()) {
      this.showError('Please select Session, Course and Exam first.');
      return;
    }

    const isEval = label === 'Evaluation';
    if (isEval) this.isDownloadingEvaluation = true;
    else        this.isDownloadingZero = true;

    this.spinner.show();

    const v = this.reportForm.value;
    const userId = parseInt(sessionStorage.getItem('userId'), 10) || 0;

   
    const spParams: any = {
      CoCode: v.course,
      SnNo:   v.SessionId,
      EmId:   v.EmId,
      IsZero: isZero
    };

    const rptCode = isEval
      ? this.EVALUATION_RPT_CODE
      : this.ZERO_MARKS_RPT_CODE;

    const filter = this.buildFilter(rptCode, spParams);

    console.log(`[${label}] HBS payload:`, filter);
    this.reportService.generateHbsReport(filter);

    setTimeout(() => {
      this.spinner.hide();
      if (isEval) this.isDownloadingEvaluation = false;
      else        this.isDownloadingZero = false;
    }, 1500);
  }



  private showSuccess(message: string): void {
    const data: any = { message, title: 'Information', icon: 'fas fa-check' };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  private showError(message: string): void {
    const data: any = { message, title: 'Error', icon: 'fas fa-times' };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }
}